export const RESET_PASSWORD_MSG = "We have send link to registered email";